import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";

const AskExpert = () => {
  return (
    <div className="container py-4" style={{ maxWidth: "400px" }}>
      {/* Header */}
      <div className="d-flex align-items-center mb-4">
        <a href="https://whatsapp.vidhvaa.com/">
          {" "}
          <FaArrowLeft size={18} style={{ cursor: "pointer", color:"black" }} />
        </a>
        <h3 className="ps-3 my-3 fw-semibold" style={{ color: "#FFAF01" }}>
          CALL TO EXPERT
        </h3>
      </div>

      {/* Top Image */}
      <div className="text-center mb-4">
        <img
          alt="phone"
          src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/image50415_IMG.png"
        />
      </div>

      {/* Buttons */}
      <div className="d-grid gap-3">
        <a href="tel:+919876543210" className="text-decoration-none">
          <button
            className="btn w-100 py-3 px-5 rounded-4 fw-semibold shadow-sm d-flex justify-content-between align-items-center"
            style={{ backgroundColor: "#FFAF01" }}
          >
            <span>Make a call</span>
            <FaArrowRight />
          </button>
        </a>

        <a
          href="https://wa.me/919876543210"
          target="_blank"
          rel="noreferrer"
          className="text-decoration-none"
        >
          <button
            className="btn w-100 py-3 px-5 rounded-4 fw-semibold shadow-sm d-flex justify-content-between align-items-center"
            style={{ backgroundColor: "#FFAF01" }}
          >
            <span>Chat with our Team</span>
            <FaArrowRight />
          </button>
        </a>

        <a
          href="https://chat.whatsapp.com/your-group-link"
          target="_blank"
          rel="noreferrer"
          className="text-decoration-none"
        >
          <button
            className="btn w-100 py-3 px-5 rounded-4 fw-semibold shadow-sm d-flex justify-content-between align-items-center"
            style={{ backgroundColor: "#FFAF01" }}
          >
            <span>Join Community</span>
            <FaArrowRight />
          </button>
        </a>
      </div>
    </div>
  );
};

export default AskExpert;
